import styled, { css } from 'styled-components';

export const Tile = styled.div<{ $isClickable: boolean }>(
  ({ theme: { palette }, $isClickable }) => css`
    background-color: ${palette.common.white};
    border: 1px solid ${palette.grey[300]};
    border-radius: 8px;
    padding: 16px 18px;
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-width: 0;
    cursor: ${$isClickable ? 'pointer' : 'default'};

    &:hover {
      border-color: ${$isClickable ? palette.primary.main : palette.grey[300]};
    }
  `,
);

export const Label = styled.div(
  ({ theme: { palette } }) => css`
    font-size: 12px;
    font-weight: 600;
    color: ${palette.grey[600]};
    letter-spacing: 0.04em;
    text-transform: uppercase;
  `,
);

export const ValueRow = styled.div`
  display: flex;
  align-items: baseline;
  gap: 10px;
  min-width: 0;
`;

export const Value = styled.span<{ $tone: 'default' | 'ok' | 'warn' | 'bad' }>(
  ({ theme: { palette }, $tone }) => css`
    font-size: 30px;
    font-weight: 700;
    line-height: 1.1;
    color: ${$tone === 'ok'
      ? palette.chart.ok
      : $tone === 'warn'
      ? palette.chart.warn
      : $tone === 'bad'
      ? palette.chart.bad
      : palette.text.secondary};
  `,
);

export const Delta = styled.span<{ $tone: 'good' | 'bad' | 'neutral' }>(
  ({ theme: { palette }, $tone }) => css`
    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;
    color: ${$tone === 'good' ? '#06B37D' : $tone === 'bad' ? palette.chart.bad : palette.grey[600]};
  `,
);

export const Caption = styled.div(
  ({ theme: { palette } }) => css`
    font-size: 12px;
    color: ${palette.grey[600]};
  `,
);
